import React from 'react';
import { ListHorizontal } from 'ui/components';
import { currencyFormat } from 'utilities/common';
import { formatDate } from 'utilities/common';

export const Submit = ({ detail, moda }) => {
  return (
    <div className="">
      <div className="row">
        <div className="col-md-6">
          <ListHorizontal
            title="Jadwal"
            content={formatDate(detail?.schedule?.default, 'DD MMMM YYYY')}
          />
        </div>
        {detail?.vendor && (
          <div className="col-md-6">
            <ListHorizontal title="Vendor" content={detail?.vendor?.name} />
          </div>
        )}

        <div className="col-md-6">
          <ListHorizontal
            title="Harga "
            content={currencyFormat(detail?.total_cost, 'IDR')}
          />
        </div>
      </div>

      <div>
        <div className="row">
          <div className="col-md-6">
            <ListHorizontal title="Driver" content={moda?.name} />
          </div>
          <div className="col-md-6">
            <ListHorizontal title="No. Polisi" content={moda?.vehicle_number} />
          </div>
          <div className="col-md-6">
            <ListHorizontal title="Kontak" content={moda?.phone_number} />
          </div>
          <div className="col-md-6">
            <ListHorizontal
              title="Kendaraan"
              content={moda?.vehicle ? moda?.vehicle?.code : moda?.vehicle_type?.name}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
